import { render, staticRenderFns } from "./UserLevelBadge.vue?vue&type=template&id=c1a3f3dc&"
import script from "./UserLevelBadge.vue?vue&type=script&lang=js&"
export * from "./UserLevelBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1a3f3dc')) {
      api.createRecord('c1a3f3dc', component.options)
    } else {
      api.reload('c1a3f3dc', component.options)
    }
    module.hot.accept("./UserLevelBadge.vue?vue&type=template&id=c1a3f3dc&", function () {
      api.rerender('c1a3f3dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/HeaderBar/UserLevelBadge.vue"
export default component.exports